import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { TUnitType, UnitCodeFromUnitType } from "@cmodules/checklist/assets/data/types/vm/template-builder/unit-code"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

// const VALID_UNIT_CODES = UnitTypes.flatMap(x => Object.values(x.mapReverseValueOptions ?? {}))

interface ICalculationItem {
  id: string;
  key: string;
  default_value: number;
  unit: UnitCodeFromUnitType
}
interface ICalculation {
  value: string;
  items: ICalculationItem[]
}

export class CalculationOptionsVM extends CommonOptionVM {
  editable?: boolean
  require_media?: boolean
  require_note?: boolean
  grouping_separator?: boolean
  calculations?: ICalculation
  units?: UnitCodeFromUnitType[]
  unit_type?: TUnitType
  simple_rule?: SimpleRuleItem[];

  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<CalculationOptionsVM> = {}) {
    super(data)
    this.editable = data.editable || undefined
    this.require_media = data.require_media || undefined
    this.require_note = data.require_note || undefined
    this.grouping_separator = data.grouping_separator || undefined
    this.calculations = data.calculations || undefined
    this.units = data.units || undefined
    this.unit_type = data.unit_type || undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  // Type guard for narrowing
  //   isUnitCode() {
  //     return UnitTypesMap
  //     // return VALID_UNIT_CODES
  //     // return typeof value === 'string' && VALID_UNIT_CODES.has(value as UnitCodeFromUnitTypes);
  //   }

  validateData() {
    const errors: any[] = []
    if (this.calculations?.items.length === 0) {
      errors.push({ key: 'calculations.items', error_message: 'Calculations items must not be empty' })
    }
    /**
    * *** ### Add check for units types
    *  */
    // if (this.units && this.units.length > 0 && this.units.filter(x => UnitTypesMap.includes(x))) {
    //   errors.push({key: 'units', error_message: 'Calculations items must not be empty'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default CalculationOptionsVM
